import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import SoundCSSTransition from '../../components/atoms/SoundCSSTransition.Container';
import Image from '../../components/atoms/Image';
import NextMapLayer from '../../components/molecules/NextMapLayer';
import SpeechBubble from '../../components/atoms/SpeechBubble';
import AutofitText from '../../components/molecules/AutofitText';
import Text from '../../components/atoms/Text';
import Assets from '../../assets/Assets';
import Pointer from '../../components/atoms/Pointer';
import PointerAnimation from '../../assets/styles/Pointer.module.css';

const SCORE_BEGIN = '1vmin + 1.2vw + 8vmin + (3 * 1.2vw) + 8vmin + (3 * 1.2vw)';

export interface Props {
	onNext: () => void;
}

const ScoreIntroScreen: FunctionComponent<Props> = (props: Props) => {
	const { onNext } = props;
	const { t } = useTranslation();

	return (
		<>
			{/* Narrator */}
			<>
				<SoundCSSTransition
					classNames="narrator"
					soundUrl={Assets.sounds.personMoves}
					timeout={1_000}
					mountOnEnter
				>
					<Image
						src={Assets.images['narrator.skeptical.body']}
						width="38vmin"
						height="56vmin"
						position="absolute"
						left="46%"
						bottom="0"
					/>
				</SoundCSSTransition>
				<SpeechBubble
					anchor="right_bottom"
					position="absolute"
					width="44%"
					height="54%"
					right="54%"
					bottom="22vmin"
					fadeInDelay={1_000}
					fadeInDuration={300}
				>
					<AutofitText>
						<Text
							content={t('introduction.score.description', {
								returnObjects: true
							})}
						/>
					</AutofitText>
				</SpeechBubble>
			</>
			<Pointer
				key="pointer_quality_of_life"
				className={PointerAnimation.first}
				rotate={-95}
				position="absolute"
				right={`calc(${SCORE_BEGIN} + 18vmin + (2 * 1.2vw) + 18vmin + (2 * 1.2vw) + 4vmin)`}
				top="13vmin"
			/>
			<Pointer
				key="pointer_environment"
				className={PointerAnimation.second}
				rotate={-85}
				position="absolute"
				right={`calc(${SCORE_BEGIN} + 18vmin + (2 * 1.2vw) + 4vmin)`}
				top="13vmin"
			/>
			<Pointer
				key="pointer_happiness"
				className={PointerAnimation.third}
				rotate={-80}
				position="absolute"
				right={`calc(${SCORE_BEGIN} + 4vmin)`}
				top="13vmin"
			/>
			<NextMapLayer text={t('introduction.score.next')} onNext={onNext} />
		</>
	);
};

export default ScoreIntroScreen;
